export const EMAIL_INPUT_ERRORS = {
  INVALID_EMAIL: 'emailInput.invalidEmail',
};
